import React from 'react'
import { Content } from 'organisms/Content'
import translate from 'core/translate'

export const NotFound = () => <Content title="404">{translate('pageNotFound')}</Content>
